(() => {
  const MENU_SEL      = '.js-mobile-menu';
  const OPEN_BTN_SEL  = '.js-open-mobile-menu';
  const CLOSE_BTN_SEL = '.js-close-mobile-menu';
  const TOGGLE_SEL    = '.js-toggle-mobile-menu';
  const PANEL_SEL     = '.js-mobile-submenu';
  const MENU_OPEN_DELAY  = 50;
  const MENU_CLOSE_DELAY = 300;  
  const SUBMENU_DUR      = 300; 

  let locks = 0;
  const lockScroll = () => {
    if (!locks++) {
      const sb = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = sb > 0 ? sb + 'px' : '';
      document.body.style.overflow = 'hidden';
    }
  };
  const unlockScroll = () => {
    if (locks > 0 && --locks === 0) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  };

  const qs  = (sel, root=document) => root.querySelector(sel);
  const qsa = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const getTarget = (btn, fallbackSel) => {
    const sel = btn.getAttribute('data-target');
    if (sel) { try { return document.querySelector(sel); } catch(_) {} }
    return btn.nextElementSibling?.matches(fallbackSel) ? btn.nextElementSibling
         : btn.closest('li, .menu-item, .js-mobile-menu-item')?.querySelector(fallbackSel);
  };

  const prepPanel = (panel) => {
    if (!panel || panel.__prepped) return;
    panel.__prepped = true;
    panel.style.overflow = 'hidden';
    panel.style.transition = `max-height ${SUBMENU_DUR}ms ease`;
    panel.style.maxHeight = panel.classList.contains('is-open') ? panel.scrollHeight + 'px' : '0';
    panel.setAttribute('aria-hidden', panel.classList.contains('is-open') ? 'false' : 'true');
  };

  const toggleSubmenu = (btn) => {
    const panel = getTarget(btn, PANEL_SEL);
    if (!panel) return;

    prepPanel(panel);

    const willOpen = !panel.classList.contains('is-open');

    if (willOpen) {
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.setAttribute('aria-hidden', 'false');
      btn.classList.add('active');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0';
      panel.setAttribute('aria-hidden', 'true');
      btn.classList.remove('active');
      btn.setAttribute('aria-expanded', 'false');
    }
  };

  const openMenu = (menu) => {
    if (!menu) return;
    menu.classList.remove('hide');
    menu.classList.add('display');
    lockScroll();
    setTimeout(() => { menu.classList.add('show'); }, MENU_OPEN_DELAY);
  };

  const closeMenu = (menu) => {
    if (!menu) return;
    menu.classList.add('hide');
    setTimeout(() => {
      menu.classList.remove('hide', 'show', 'display');
      unlockScroll();
    }, MENU_CLOSE_DELAY);
  };

  document.addEventListener('click', (e) => {
    const openBtn  = e.target.closest(OPEN_BTN_SEL);
    if (openBtn) {
      e.preventDefault();
      const menu = getTarget(openBtn, MENU_SEL) || qs(MENU_SEL);
      openMenu(menu);
      return;
    }

    const closeBtn = e.target.closest(CLOSE_BTN_SEL);
    if (closeBtn) {
      e.preventDefault();
      const menu = getTarget(closeBtn, MENU_SEL) || qs(MENU_SEL);
      closeMenu(menu);
      return;
    }

    const toggleBtn = e.target.closest(TOGGLE_SEL);
    if (toggleBtn) {
      e.preventDefault();
      toggleSubmenu(toggleBtn);
      return;
    }
  });

  qsa(PANEL_SEL).forEach(prepPanel);
})();